import { BaseDto } from "@/shared/dtos/base-dto";

export class alegaciones_lote extends BaseDto {
  public id_empleado_fk!: number;
  public id_fichaje_fk!: number;
  public token_grupo!: string;
  public estado_lote!: string; // 'PENDIENTE' | 'ACEPTADA' | 'DISCREPANCIA' | 'PARCIAL'
  public fecha_envio_email!: Date;
  public fecha_respuesta!: Date;

  constructor(src?: any, enableTrackChanges: boolean = false) {
    super(src, enableTrackChanges);
  }
}
